import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "react-lazy-load-image-component/src/effects/blur.css";
import App from "./App";
import "../src/styles/global.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode>
    <BrowserRouter>
            <App />
    </BrowserRouter>
</React.StrictMode>
);


